import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ClientMessage } from 'owa-mail-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import MeetingIcon from './MeetingIcon';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import SenderSummary from './SenderSummary';
import { SenderPersona } from 'owa-mail-sender-persona-view';
import MessageSafetyLevel from 'owa-service/lib/contract/MessageSafetyLevel';

const styles = require('./CollapsedMeetingMessage.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CollapsedMeetingMessageProps {
    item: ClientMessage;
    refCallback: (instance: HTMLDivElement) => any;
    toggleExpandCollapse: () => void;
    isFocused: boolean;
    timeStamp?: JSX.Element;
    onDidMount?: () => void;
}

const CollapsedMeetingMessage = observer(function CollapsedMeetingMessage(
    props: CollapsedMeetingMessageProps
) {
    const { item, refCallback, toggleExpandCollapse, isFocused, timeStamp, onDidMount } = props;

    React.useEffect(() => {
        onDidMount && onDidMount();
    }, [onDidMount]);

    const onClickCallback = React.useCallback(() => {
        toggleExpandCollapse();
    }, [toggleExpandCollapse]);

    return (
        <div
            className={classNames(styles.container, {
                isFocused: isFeatureEnabled('rp-selectionUI') && isFocused,
            })}
            ref={refCallback}
            onClick={onClickCallback}
            tabIndex={-1}>
            <MeetingIcon message={item as MeetingMessage} />
            <span className={styles.summaryContainer}>
                <SenderSummary
                    message={item}
                    senderPersona={
                        <SenderPersona
                            sender={item.From}
                            isRead={item.IsRead}
                            treatAsDraft={false}
                            displaySelf={false}
                            hideSMTP={false}
                            messageSafetyLevel={
                                item.MessageSafety
                                    ? item.MessageSafety.MessageSafetyLevel
                                    : MessageSafetyLevel.None
                            }
                            isUnauthenticatedSender={item.AntispamUnauthenticatedSender}
                            className={styles.sender}
                            displayYouForSelf={true}
                        />
                    }
                />
            </span>
            {timeStamp && <span className={styles.sentTime}>{timeStamp}</span>}
        </div>
    );
});

export default CollapsedMeetingMessage;
